/**
 * Extention for web3.js. Adds "nrg" and "energi" unit maps to web3.
 *
 * Usage:
 *
 * Web3 = require('web3');
 * extendUnitMaps = require('./lib/energi-unit-maps')
 *
 * web3 = new Web3();
 * extendUnitMaps(web3);
 * amountWei = web3.utils.toWei('1', 'nrg'); // <- '1000000000000000000'
 * amountWei = web3.utils.toWei('1', 'energi'); // <- '1000000000000000000'
 *
 * <i>Copyright (c) 2020 Energi Cryptocurrency - https://energi.world</i><br>
 * BSD-3-Clause License
 *
 *
 * @module energi-unit-maps.js
 * @extends web3
 * @since 0.1.0
*/
var ENERGI_MAP = [{
  key: 'noenergi',
  value: '0'
}, {
  key: 'femtoenergi',
  value: '1000'
}, {
  key: 'picoenergi',
  value: '1000000'
}, {
  key: 'nanoenergi',
  value: '1000000000'
}, {
  key: 'microenergi',
  value: '1000000000000'
}, {
  key: 'millienergi',
  value: '1000000000000000'
}, {
  key: 'energi',
  value: '1000000000000000000'
}, {
  key: 'kenergi',
  value: '1000000000000000000000'
}, {
  key: 'menergi',
  value: '1000000000000000000000000'
}, {
  key: 'genergi',
  value: '1000000000000000000000000000'
}, {
  key: 'tenergi',
  value: '1000000000000000000000000000000'
}];
var NRG_MAP = [{
  key: 'nonrg',
  value: '0'
}, {
  key: 'femtonrg',
  value: '1000'
}, {
  key: 'piconrg',
  value: '1000000'
}, {
  key: 'nanonrg',
  value: '1000000000'
}, {
  key: 'micronrg',
  value: '1000000000000'
}, {
  key: 'millinrg',
  value: '1000000000000000'
}, {
  key: 'nrg',
  value: '1000000000000000000'
}, {
  key: 'knrg',
  value: '1000000000000000000000'
}, {
  key: 'mnrg',
  value: '1000000000000000000000000'
}, {
  key: 'gnrg',
  value: '1000000000000000000000000000'
}, {
  key: 'tnrg',
  value: '1000000000000000000000000000000'
}];

var extend = function extend(web3) {
  ENERGI_MAP.forEach(function (unit) {
    return web3.utils.unitMap[unit.key] = unit.value;
  });
  NRG_MAP.forEach(function (unit) {
    return web3.utils.unitMap[unit.key] = unit.value;
  });
};

module.exports = extend;